;(function (): void {
  'use strict'

  function initializeSiteHome(): void {
    const nav = document.querySelector<HTMLElement>('.site-nav-js')
    const revealElements = Array.from(document.querySelectorAll<HTMLElement>('.reveal-js'))

    if (!nav && revealElements.length === 0) return

    const updateNavBorder = (): void => {
      if (!nav) return

      if (window.scrollY > 8) {
        nav.classList.remove('border-transparent')
        nav.classList.add('border-stroke-muted')
      } else {
        nav.classList.add('border-transparent')
        nav.classList.remove('border-stroke-muted')
      }
    }

    updateNavBorder()
    window.addEventListener('scroll', updateNavBorder, { passive: true })

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      revealElements.forEach((element) => {
        element.classList.remove('opacity-0', 'translate-y-4')
      })
      return
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          entry.target.classList.remove('opacity-0', 'translate-y-4')
          entry.target.classList.add('opacity-100', 'translate-y-0')
          observer.unobserve(entry.target)
        })
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    )

    revealElements.forEach((element, index) => {
      element.style.transitionDelay = `${(index % 4) * 60}ms`
      observer.observe(element)
    })
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSiteHome)
  } else {
    initializeSiteHome()
  }
})()
